export const partnerMerchants = {
  topPicks: [
    {
      logo: 'https://cdn.shippingcart.com/assets/6pm-20200127083844.svg',
      alt: '6pm Logo',
      link: 'https://www.6pm.com/'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/disney-20200127083844.svg',
      alt: 'Disney Logo',
      link: 'https://www.disney.ph/'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/walgreens-20200127083844.svg',
      alt: 'Walgreens Logo',
      link: 'https://www.walgreens.com/'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/benefit-20200127083844.svg',
      alt: 'Benefit Cosmetics Logo',
      link: 'https://www.benefitcosmetics.com/ph/en'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/carters-20200127083843.svg',
      alt: 'Carters Logo',
      link: 'https://www.carters.com/'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/bath-body-works-20200127083844.svg',
      alt: 'Bath Body Works Logo',
      link: 'https://www.bathandbodyworks.com/'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/gap-20200127083843.svg',
      alt: 'Gap Logo',
      link: 'https://www.gap.com/'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/forever-21-20200127083844.svg',
      alt: 'Forever21 Logo',
      link: 'https://www.forever21.com/us/Shop'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/victoria-secret-20200127083844.svg',
      alt: 'Victoria Secret Logo',
      link: 'https://www.victoriassecret.com/'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/adidas-20200127083843.svg',
      alt: 'Addidas Logo',
      link: 'https://www.adidas.com/us'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/amazon-20200127083843.svg',
      alt: 'Amazon Logo',
      link: 'https://www.amazon.com/'
    },
  ],
  fashionBeauty: [
    {
      logo: 'https://cdn.shippingcart.com/assets/525-america-20200206093302.svg',
      alt: '525 America Logo',
      link: 'www.525america.com'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/aldo-20200206093302.svg',
      alt: 'Aldo Shoes Logo',
      link: 'https://www.aldoshoes.com/us/en_US'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/allurez-20200206093305.svg',
      alt: 'Allurez Logo',
      link: 'https://www.allurez.com/'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/american-eagle-20200206093302.svg',
      alt: 'American Eagel Logo',
      link: 'https://www.ae.com/us/en'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/ann-taylor-20200206093303.svg',
      alt: 'Ann Taylor Logo',
      link: 'https://www.anntaylor.com/'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/armani-exchange-20200206093302.svg',
      alt: 'Armani Exchange Logo',
      link: 'https://www.armaniexchange.com/us'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/colour-pop-20200206093302.svg',
      alt: 'Colour Pop Logo',
      link: 'https://colourpop.com/'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/kipling-usa-20200206093302.svg',
      alt: 'Kipling Logo',
      link: 'https://www.kipling-usa.com/'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/backcountry-20200206093301.svg',
      alt: 'Backcountry Logo',
      link: 'https://www.backcountry.com/'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/bagking-20200206093305.svg',
      alt: 'Bag King Logo',
      link: 'https://www.bagking.com/'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/banana-republic-20200206093302.svg',
      alt: '6pm Logo',
      link: 'https://bananarepublic.gap.com/'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/beauty-bar-20200206093306.svg',
      alt: 'Beauty Bar Logo',
      link: 'https://www.amazon.com/b/ref=beautybar_redirect?node=16575127011'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/bh-cosmetics-20200206093305.svg',
      alt: 'BH Cosmetics Logo',
      link: 'https://www.bhcosmetics.com/'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/bhfo-20200206093305.svg',
      alt: 'BHFO Logo',
      link: 'https://www.bhfo.com/'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/bliss-20200206093302.svg',
      alt: 'Bliss World Logo',
      link: 'https://www.blissworld.com/'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/burton-20200206093302.svg',
      alt: 'Burton Logo',
      link: 'https://www.burton.com/us/en/home'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/crocs-20200206093301.svg',
      alt: 'Crocs Logo',
      link: 'https://www.crocs.com/'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/diesel-20200206093302.svg',
      alt: 'Diesel Logo',
      link: 'https://global.diesel.com/home'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/dorothy-perkins-20200206093302.svg',
      alt: 'Dorothy Perkins Logo',
      link: 'https://us.dorothyperkins.com/'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/ebags-20200206093303.svg',
      alt: 'EBags Logo',
      link: 'https://www.ebags.com/'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/haute-look-20200206093302.svg',
      alt: 'Hautelook Logo',
      link: 'https://www.hautelook.com/'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/burton-20200206093302.svg',
      alt: 'Inernational Jock Logo',
      link: 'http://www.internationaljock.com/'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/jcrew-20200206093301.svg',
      alt: 'Jcrew Logo',
      link: 'https://www.jcrew.com/'
    },
    {
      logo: 'https://cdn.shippingcart.com/assets/juicy-couture-20200206093304.svg',
      alt: 'Juicy Couture Logo',
      link: 'http://www.juicycouture.com/'
    },
    {
      link:'https://www.karmaloop.com/',
      alt: 'Karma Loop Logo',
      logo: 'https://cdn.shippingcart.com/assets/karma-loop-20200206093302.svg'
    },
    {
      link:'https://www.lacoste.com/us/',
      alt: 'Lacoste Logo',
      logo: 'https://cdn.shippingcart.com/assets/lacoste-20200206093302.svg'
    },
    {
      link:'https://www.saksfifthavenue.com/',
      alt: 'Saks Fifth Avenue Logo',
      logo: 'https://cdn.shippingcart.com/assets/saks-fifth-avenue-20200206093304.svg'
    },
    {
      link:'https://www.luckybrand.com/',
      alt: 'Lucky Brand Logo',
      logo: 'https://cdn.shippingcart.com/assets/lucky-brand-20200206093302.svg'
    },
    {
      link:'https://www.maidenform.com/',
      alt: 'Maiden Form Logo',
      logo: 'https://cdn.shippingcart.com/assets/maiden-form-20200206093959.svg'
    },
    {
      link:'https://www.marcjacobs.com/',
      alt: 'Marc Jacobs Logo',
      logo: 'https://cdn.shippingcart.com/assets/marc-jacobs-20200206093302.svg'
    },
    {
      link:'https://www.modcloth.com/on/demandware.store/Sites-modcloth-Site/default/Default-Start?src=paid_brand&amp;utm_source=ppc&amp;utm_medium=google&amp;utm_campaign=G.SEM.ROW_BR.X_Brand&amp;utm_term=modcloth&amp;gclid=EAIaIQobChMIr-y5u_uM3QIVgTgrCh15NwAxEAAYASAAEgIPW_D_BwE&amp;gclsrc=aw.ds',
      alt: 'Modcloth Logo',
      logo: 'https://cdn.shippingcart.com/assets/mod-cloth-20200206093302.svg'
    },
    {
      link:'https://www.neimanmarcus.com/',
      alt: 'Neiman Marcus Logo',
      logo: 'https://cdn.shippingcart.com/assets/neiman-marcus-20200206093304.svg'
    },
    {
      link:'https://www.ninewest.com/',
      alt: 'Nine West Logo',
      logo: 'https://cdn.shippingcart.com/assets/nine-west-20200206093302.svg'
    },
    {
      link:'https://shop.nordstrom.com/',
      alt: 'Nordstorm Logo',
      logo: 'https://cdn.shippingcart.com/assets/nordstorm-20200206093302.svg'
    },
    {
      link:'https://www.paulsmith.com/us',
      alt: 'Paul Smith Logo',
      logo: 'https://cdn.shippingcart.com/assets/paul-smith-20200206093301.svg'
    },
    {
      link:'https://www.ruelala.com/boutique/',
      alt: 'Ruelala Logo',
      logo: 'https://cdn.shippingcart.com/assets/ruelala-20200206093302.svg'
    },
    {
      link:'https://www.shoes.com/',
      alt: 'Shoebuy Logo',
      logo: 'https://cdn.shippingcart.com/assets/shoebuy-20200206093301.svg'
    },
    {
      link:'https://www.skinstore.com/',
      alt: 'Skin Store Logo',
      logo: 'https://cdn.shippingcart.com/assets/skin-store-20200206093305.svg'
    },
    {
      link:'https://www.stussy.com/',
      alt: 'Stussy Logo',
      logo: 'https://cdn.shippingcart.com/assets/stussy-20200206093306.svg'
    },
    {
      link:'https://www.thehut.com/',
      alt: 'The Hut Logo',
      logo: 'https://cdn.shippingcart.com/assets/the-hut-20200206093302.svg'
    },
    {
      link:'https://www.timetospa.com/',
      alt: 'Time To Spa Logo',
      logo: 'https://cdn.shippingcart.com/assets/time-to-spa-20200206093302.svg'
    },
    {
      link:'https://www.toms.com/',
      alt: 'Toms Logo',
      logo: 'https://cdn.shippingcart.com/assets/toms-20200206093302.svg'
    },
    {
      link:'https://www.toryburch.com/',
      alt: 'Tony Burch logo',
      logo: 'https://cdn.shippingcart.com/assets/tory-burch-20200206093302.svg'
    },
    {
      link:'https://www.ugg.com/',
      alt: 'Ugg Logo',
      logo: 'https://cdn.shippingcart.com/assets/ugg-20200206093302.svg'
    },
    {
      link:'https://www.urbanoutfitters.com/',
      alt: 'Urban Outfitters Logo',
      logo: 'https://cdn.shippingcart.com/assets/urbanoutfitters-20200206093302.svg'
    },
    {
      link:'https://www.vince.com/',
      alt: 'Vince Logo',
      logo: 'https://cdn.shippingcart.com/assets/vince-20200206093302.svg'
    },
    {
      link:'https://www.whatgreatskin.com/',
      alt: 'What Great Skin Logo',
      logo: 'https://cdn.shippingcart.com/assets/what-great-skin-20200206094515.svg'
    },
    {
      link:'https://www.yoox.com/us',
      alt: 'Yoox Logo',
      logo: 'https://cdn.shippingcart.com/assets/yoox-20200206093302.svg'
    },
    {
      link:'https://www.zappos.com/',
      alt: 'Zappos Logo',
      logo: 'https://cdn.shippingcart.com/assets/zappos-20200206093304.svg'
    },
    {
      link:'https://www.kyliecosmetics.com/',
      alt: 'Kylie Cosmetics Logo',
      logo: 'https://cdn.shippingcart.com/assets/kylie-cosmetics-20200311042145.svg'
    }
  ],
  lifestlyleTech: [
    {
      link:'https://www.4allmemory.com/',
      alt: '4all Memory Logo',
      logo: 'https://cdn.shippingcart.com/assets/4-all-memory-20200206071411.svg'
    },
    {
      link:'https://www.adorama.com/',
      alt: 'Adorama Logo',
      logo: 'https://cdn.shippingcart.com/assets/adorama-20200206071412.svg'
    },
    {
      link:'https://www.bhphotovideo.com/',
      alt: 'BNH Logo',
      logo: 'https://cdn.shippingcart.com/assets/bnh-20200206071412.svg'
    },
    {
      link:'https://www.boscovs.com/ast/home-1',
      alt: 'Boscovs Logo',
      logo: 'https://cdn.shippingcart.com/assets/boscovs-20200206071412.svg'
    },
    {
      link:'https://www.amazon.com/b/ref=casa_redirect?node=16575124011',
      alt: 'Casa Logo',
      logo: 'https://cdn.shippingcart.com/assets/casa-20200206071412.svg'
    },
    {
      link:'https://www.olloclip.com/',
      alt: 'Olloclip Logo',
      logo: 'https://cdn.shippingcart.com/assets/olloclip-20200206071412.svg'
    },
    {
      link:'https://www.crucial.com/',
      alt: 'Crucial Logo',
      logo: 'https://cdn.shippingcart.com/assets/crucial-20200206071412.svg'
    },
    {
      link:'https://fab.com/',
      alt: 'Fab Logo',
      logo: 'https://cdn.shippingcart.com/assets/fab-20200206071412.svg'
    },
    {
      link:'http://www.gnc.com/',
      alt: 'GNC Logo',
      logo: 'https://cdn.shippingcart.com/assets/gnc-20200206071411.svg'
    },
    {
      link:'https://griffintechnology.com/',
      alt: 'Griffin Technology Logo',
      logo: 'https://cdn.shippingcart.com/assets/griffin-20200206071411.svg'
    },
    {
      link:'https://www.importcds.com/',
      alt: 'Importcds Logo',
      logo: 'https://cdn.shippingcart.com/assets/importcds-20200206071412.svg'
    },
    {
      link:'http://www.mwave.com/mwave/index.asp?',
      alt: 'Mwave Logo',
      logo: 'https://cdn.shippingcart.com/assets/mwave-20200206071411.svg'
    },
    {
      link:'https://www.newegg.com/',
      alt: 'NewEgg Logo',
      logo: 'https://cdn.shippingcart.com/assets/newegg-20200206071412.svg'
    },
    {
      link:'https://www.overstock.com/',
      alt: 'Overstock Logo',
      logo: 'https://cdn.shippingcart.com/assets/overstock-20200206071412.svg'
    },
    {
      link:'https://www.powersupportintl.com/',
      alt: 'Power Support Logo',
      logo: 'https://cdn.shippingcart.com/assets/power-support-20200206071411.svg'
    },
    {
      link:'https://www.amazon.com/b/ref=soap_redirect?node=16575125011',
      alt: 'Soap Logo',
      logo: 'https://cdn.shippingcart.com/assets/soap-20200206071412.svg'
    },
    {
      link:'https://www.sony.com/',
      alt: 'Sony Logo',
      logo: 'https://cdn.shippingcart.com/assets/sony-20200206071412.svg'
    },
    {
      link:'https://www.spigen.com/',
      alt: 'Spingen Logo',
      logo: 'https://cdn.shippingcart.com/assets/spigen-20200206071412.svg'
    },
    {
      link:'https://www.wayfair.com/',
      alt: 'Wayfair Logo',
      logo: 'https://cdn.shippingcart.com/assets/wayfair-20200206071412.svg'
    },
    {
      link:'https://www.xbox.com/en-SG/',
      alt: 'Xbox Logo',
      logo: 'https://cdn.shippingcart.com/assets/xbox-20200206071412.svg'
    },
    {
      link:'https://www.zagg.com/us/en_us/',
      alt: 'Zagg Logo',
      logo: 'https://cdn.shippingcart.com/assets/zagg-20200206071412.svg'
    },
  ],
  toysKids: [
    {
      link:'https://www.amazon.com/b/ref=yoyo_redirect?node=16575126011',
      alt: 'Yoyo Logo',
      logo: 'https://cdn.shippingcart.com/assets/yoyo-20200206055815.svg'
    },
    {
      link:'https://www.thinkgeek.com/',
      alt: 'Logo',
      logo: 'https://cdn.shippingcart.com/assets/think-geek-20200206055815.svg'
    },
    {
      link:'https://www.childrensplace.com/us/home',
      alt: 'Logo',
      logo: 'https://cdn.shippingcart.com/assets/the-childrens-place-20200206055814.svg'
    },
    {
      link:'https://seekairun.com/',
      alt: 'Logo',
      logo: 'https://cdn.shippingcart.com/assets/see-kai-run-20200206055814.svg'
    },
    {
      link:'https://www.partycity.com/',
      alt: 'Logo',
      logo: 'https://cdn.shippingcart.com/assets/party-city-20200206055815.svg'
    },
    {
      link:'https://www.oshkosh.com/',
      alt: 'Logo',
      logo: 'https://cdn.shippingcart.com/assets/oshkosh-20200206055814.svg'
    },
    {
      link:'http://www.orientaltrading.com/',
      alt: 'Logo',
      logo: 'https://cdn.shippingcart.com/assets/oriental-trading-20200206055815.svg'
    },
    {
      link:'https://mini-la-mode.com/',
      alt: 'Logo',
      logo: 'https://cdn.shippingcart.com/assets/mini-la-mode-20200206055814.svg'
    },
    {
      link:'https://www.melissaanddoug.com/',
      alt: 'Logo',
      logo: 'https://cdn.shippingcart.com/assets/melissa-doug-20200206055815.svg'
    },
    {
      link:'https://www.mattel.com/en-us',
      alt: 'Logo',
      logo: 'https://cdn.shippingcart.com/assets/mattel-20200206055814.svg'
    },
    {
      link:'https://www.leapfrog.com/en-us/home',
      alt: 'Logo',
      logo: 'https://cdn.shippingcart.com/assets/leapfrog-20200206055815.svg'
    },
    {
      link:'https://www.shopjustice.com/',
      alt: 'Logo',
      logo: 'https://cdn.shippingcart.com/assets/justice-20200206055815.svg'
    },
    {
      link:'https://www.iseeme.com/en-us/',
      alt: 'Logo',
      logo: 'https://cdn.shippingcart.com/assets/iseeme-20200206055815.svg'
    },
    {
      link:'https://www.gymboree.com/',
      alt: 'Logo',
      logo: 'https://cdn.shippingcart.com/assets/gymboree-20200206055815.svg'
    },
    {
      link:'https://www.fisher-price.com/en_SEA/index.html',
      alt: 'Logo',
      logo: 'https://cdn.shippingcart.com/assets/fisher-price-20200206055815.svg'
    },
    {
      link:'https://www.amazon.com/b/ref=diapers_redirect?node=16575122011',
      alt: 'Logo',
      logo: 'https://cdn.shippingcart.com/assets/diapers-20200206055815.svg'
    },
    {
      link:'https://www.cathkidston.com/',
      alt: 'Logo',
      logo: 'https://cdn.shippingcart.com/assets/cath-kidston-20200206055815.svg'
    },
    {
      link:'https://www.californiababy.com/',
      alt: 'Logo',
      logo: 'https://cdn.shippingcart.com/assets/california-baby-20200206055814.svg'
    },
    {
      link:'https://www.babyearth.com/',
      alt: 'Logo',
      logo: 'https://cdn.shippingcart.com/assets/baby-earth-20200206055814.svg'
    },
  ],
  sportsHobbyHealth: [
    {
      link:'https://www.yogaoutlet.com/?10np&amp;utm_source=yolinkshare&amp;utm_medium=affiliate&amp;utm_campaign=LSgcknZyZpA&amp;utm_content=152&amp;siteID=LSgcknZyZpA-8zvnb71AeBlY0CckqNQ4jg',
      alt: 'Yoga Outlet Logo',
      logo: 'https://cdn.shippingcart.com/assets/yoga-outlet-20200206082819.svg'
    },
    {
      link:'https://www.betterworldbooks.com/',
      alt: 'Better World Books Logo',
      logo: 'https://cdn.shippingcart.com/assets/better-world-books-20200206082819.svg'
    },
    {
      link:'https://www.bodybuilding.com/store/bodybuilding.html',
      alt: 'Body Building Logo',
      logo: 'https://cdn.shippingcart.com/assets/body-building-20200206082819.svg'
    },
    {
      link:'https://www.burton.com/us/en/home',
      alt: 'Burton Logo',
      logo: 'https://cdn.shippingcart.com/assets/burton-20200206082819.svg'
    },
    {
      link:'https://www.callawaygolf.com/',
      alt: 'Callaway Logo',
      logo: 'https://cdn.shippingcart.com/assets/callaway-20200206082819.svg'
    },
    {
      link:'https://www.christianbook.com/',
      alt: 'Christian Book Logo',
      logo: 'https://cdn.shippingcart.com/assets/christian-book-20200206082819.svg'
    },
    {
      link:'https://www.eastbay.com/',
      alt: 'Eastbay Logo',
      logo: 'https://cdn.shippingcart.com/assets/eastbay-20200206082819.svg'
    },
    {
      link:'https://www.finishline.com/',
      alt: 'Finish Line Logo',
      logo: 'https://cdn.shippingcart.com/assets/finish-line-20200206082819.svg'
    },
    {
      link:'https://www.footaction.com/',
      alt: 'Foot Action Logo',
      logo: 'https://cdn.shippingcart.com/assets/footaction-20200206082819.svg'
    },
    {
      link:'https://www.herbalife.com/',
      alt: 'Herbal Life Logo',
      logo: 'https://cdn.shippingcart.com/assets/herbal-life-20200206082819.svg'
    },
    {
      link:'https://www.iherb.com/',
      alt: 'iHerb Logo',
      logo: 'https://cdn.shippingcart.com/assets/iherb-20200206082819.svg'
    },
    {
      link:'https://www.luckyvitamin.com/',
      alt: 'Lucky Vitamin Logo',
      logo: 'https://cdn.shippingcart.com/assets/lucky-vitamin-20200206082819.svg'
    },
    {
      link:'https://shop.lululemon.com/',
      alt: 'Lululemon Logo',
      logo: 'https://cdn.shippingcart.com/assets/lululemon-20200206082819.svg'
    },
    {
      link:'https://www.moosejaw.com/',
      alt: 'Moosejaw Logo',
      logo: 'https://cdn.shippingcart.com/assets/moosejaw-20200206082819.svg'
    },
    {
      link:'https://moskomoto.com/',
      alt: 'Mosko Moto Logo',
      logo: 'https://cdn.shippingcart.com/assets/mosko-moto-20200206082819.svg'
    },
    {
      link:'https://www.nuskin.com/content/nuskin/en_US/home.html',
      alt: 'Nuskin Logo',
      logo: 'https://cdn.shippingcart.com/assets/nuskin-20200206082819.svg'
    },
    {
      link:'https://www.rockbottomgolf.com/',
      alt: 'Rock Bottom Golf Logo',
      logo: 'https://cdn.shippingcart.com/assets/rock-bottom-golf-20200206082819.svg'
    },
    {
      link:'https://www.runningwarehouse.com/',
      alt: 'Running Warehouse Logo',
      logo: 'https://cdn.shippingcart.com/assets/running-warehouse-20200206082819.svg'
    },
    {
      link:'https://www.swansonvitamins.com/',
      alt: 'Swanson Logo',
      logo: 'https://cdn.shippingcart.com/assets/swanson-20200206082819.svg'
    },
    {
      link:'https://www.tennis-warehouse.com/',
      alt: 'Tennis Warehouse Logo',
      logo: 'https://cdn.shippingcart.com/assets/tennis-warehouse-20200206082819.svg'
    },
    {
      link:'https://www.thriftbooks.com/',
      alt: 'Thriftbooks Logo',
      logo: 'https://cdn.shippingcart.com/assets/thriftbooks-20200206082819.svg'
    },
    {
      link:'https://www.vitacost.com/',
      alt: 'Vita Cost Logo',
      logo: 'https://cdn.shippingcart.com/assets/vita-cost-20200206082819.svg'
    }
  ]
}

export const banners = [
  {
    img: 'https://cdn.shippingcart.com/assets/origin-banner-large-20200128072801.jpg',
    alt: 'origin-banner-large',
    customClass: 'large-banner',
  },
  {
    img: 'https://cdn.shippingcart.com/assets/origin-banner-small-20200128072801.jpg',
    alt: 'origin-banner-small',
    customClass: 'small-banner',
  }
]


/** WEBPACK FOOTER **
 ** ./src/components/USShopping/constants.js
 **/